import { api } from '@creditsights/api-ui-web';
import { CovenantComparisonResults } from '../models/Securities';
import { addDateFilter } from '../utils/date.utils';
import { filterMapper } from '../utils/filter.utils';
import { fixCountryNamesBaseOnTags, mapSectors } from '../utils/tag.utils';
import { fetchFilters } from './filter.service';

const API_URL = 'common/v1/securities/comparison/covenants';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchCovenantCompareFilters = async () => {
  const filters = [
    {
      id: 'issuer',
      name: 'Issuers',
    },
    {
      id: 'region',
      name: 'Region',
    },
    {
      id: 'sectors',
      name: 'Sector/Subsector',
    },
    {
      id: 'country_code',
      name: 'Country',
    },
    {
      id: 'use_of_proceeds',
      name: 'Use of Proceeds (UOP)',
    },
    {
      id: 'interest_rate_type',
      name: 'Interest rate type',
    },
    {
      id: 'issuer_lawfirms',
      name: 'Issuer Law Firm',
    },
    {
      id: 'underwriter_lawfirms',
      name: 'Underwriter Law Firm',
    },
  ];

  const promises = filters.map((filter) =>
    api.post(`${API_URL}/filters/${filter.id}`, {
      filters: {},
      take: 5000,
    })
  );

  const [results, tagFilters] = await Promise.all([Promise.all(promises), fetchFilters()]);
  const resp: any = {};

  results.forEach((result, index) => {
    const filter = filters[index];

    resp[filter.id] = {
      name: filter.name,
      data: filterMapper(result.data.filter((i) => !!i)),
    };
  });

  resp.country_code.data = fixCountryNamesBaseOnTags(resp.country_code.data, tagFilters.map);
  resp.sectors.data = mapSectors(tagFilters.data[6].options);
  return resp;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchCovenantCompareData = async (sort, { issueStartDate, issueEndDate }, { maturityStartDate, maturityEndDate }, filterConfig, pageSize, page = 1) => {
  const filters = {
    ...filterConfig,
  };

  addDateFilter(filters, 'issue_date', issueStartDate, issueEndDate);
  addDateFilter(filters, 'maturity_date', maturityStartDate, maturityEndDate);

  const { data } = await api.post<CovenantComparisonResults>(API_URL, {
    filters,
    skip: (page - 1) * pageSize,
    take: pageSize,
    sort: sort.field,
    sortDesc: !sort.asc,
    fields: ['cs_universal_id', 'entity_name', 'issuer', 'report_id', 'issue_name', 'interest_rate', 'interest_rate_type', 'issue_date', 'maturity_date', 'use_of_proceeds', 'country_code', 'industry', 'region', 'regions', 'sectors'],
  });

  return data;
};

const mapFields = (fields) => {
  const obj: any = {};

  for (const field of fields || []) {
    obj[`field${field.field_id}`] = field.text;
  }

  return obj;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchCovenantCompareDetailsData = async (ids) => {
  if (ids.length === 0) {
    return {
      totalResults: 0,
      results: [],
    };
  }

  const { data } = await api.post(API_URL, {
    filters: {
      _id: {
        values: ids,
      },
    },
    take: 100,
  });

  const resp: any = {};
  data.results.forEach((item) => {
    // eslint-disable-next-line no-param-reassign
    item.detailed_fields = mapFields(item.detailed_fields);
    resp[item.id] = item;
  });

  return resp;
};
